<form [formGroup]="customerStopForm"
      (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <button type="button"
            class="btn-close"
            (click)="onCloseClick()"></button>
  </div>
  <div *ngIf="!formSent; else onSuccessBody"
       class="modal-body px-5 text-break"
       ngbAutofocus>
    <h1 [innerHTML]="'SALON-DETAILS.KLANTEN-STOP.INFO-TITLE' | translate"></h1>
    <span class="d-block my-3" [innerHTML]="'SALON-DETAILS.KLANTEN-STOP.INFO' | translate"></span>
    <div class="my-3">
      <label for="customerName"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INPUT.LABEL' | translate }}</label>
      <input id="customerName"
             class="form-control"
             [ngClass]="{'is-invalid': customerNameFormControl.invalid && (customerNameFormControl.dirty || customerNameFormControl.touched || submitted),
             'is-valid': customerNameFormControl.valid }"
             formControlName="customerName"
             type="text"
             placeholder="{{ 'SALON-DETAILS.KLANTEN-STOP.PLACEHOLDER-NAME' | translate }}"
             maxlength="50"
             required>
      <div class="invalid-feedback"
           [@inOutAnimation]>{{ 'SALON-DETAILS.KLANTEN-STOP.REQUIRED-NAME' | translate }}</div>
    </div>
    <div class="mb-3">
      <label for="customerEmail"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-EMAIL.LABEL' | translate }}</label>
      <input id="customerEmail"
             class="form-control"
             [ngClass]="{'is-invalid': customerEmailFormControl.invalid && (customerEmailFormControl.dirty || customerEmailFormControl.touched || submitted),
             'is-valid': customerEmailFormControl.valid }"
             formControlName="customerEmail"
             type="text"
             placeholder="{{ 'SALON-DETAILS.KLANTEN-STOP.PLACEHOLDER-EMAIL' | translate }}"
             maxlength="254"
             required>
      <div class="invalid-feedback"
           [@inOutAnimation]>{{ 'SALON-DETAILS.KLANTEN-STOP.REQUIRED-EMAIL' | translate }}</div>
    </div>
    <h5 *ngIf="!formStatusOk"
        [@inOutAnimation]
        class="small w-auto mx-auto text-center">{{ 'SALON-DETAILS.KLANTEN-STOP.ERROR' | translate }}</h5>
  </div>
  <ng-template #onSuccessBody>
    <div class="modal-body d-flex flex-column justify-content-center px-5 text-break"
         ngbAutofocus>
      <div class="d-flex justify-content-center mb-5">
        <i-feather name="check-circle"
                   class="icon-check-circle text-primary me-3"></i-feather>
      </div>
      <h2 class="text-center mb-5"
          [innerHTML]="'SALON-DETAILS.KLANTEN-STOP.SENT' | translate"></h2>
      <span class="text-center mb-3"
            [innerHTML]="'SALON-DETAILS.KLANTEN-STOP.SUCCESS-INFO' | translate"></span>
    </div>
  </ng-template>
  <div *ngIf="!formSent; else onSuccessFooter"
       class="modal-footer d-flex justify-content-between">
    <button type="button"
            class="btn btn-outline-primary px-4"
            [translate]="'SALON-DETAILS.KLANTEN-STOP.BUTTON-CANCEL'"
            (click)="onCloseClick()">
    </button>
    <button type="submit"
            class="btn btn-primary"
            [translate]="'SALON-DETAILS.KLANTEN-STOP.BUTTON-SEND'">
    </button>
  </div>
  <ng-template #onSuccessFooter>
    <div class="modal-footer d-flex justify-content-end">
      <button type="button"
              class="btn btn-primary px-4"
              [translate]="'SALON-DETAILS.KLANTEN-STOP.BUTTON-CLOSE'"
              (click)="onCloseClick()">
      </button>
    </div>
  </ng-template>
</form>
